import axios from "axios";
import * as Sentry from "@sentry/react";

const apiRequest = axios.create({
  baseURL: process.env.REACT_APP_DATA_FARMING_API_ORIGIN,
});

apiRequest.interceptors.request.use((config) => {
  const newConfig = config;
  const transaction = Sentry.getCurrentHub().getScope().getTransaction();

  newConfig.headers["sentry-trace"] = transaction?.traceId;

  return newConfig;
});

export default apiRequest;
